/* eslint-disable import/prefer-default-export */

/**
 * "Чтение" бинарного файла как base64 строки.
 *
 * @param {Blob} data
 * @returns {Promise<string>}
 */
export const blobToBase64 = (data: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onloadend = function () {
      resolve(reader.result as string);
    };
    reader.onerror = function () {
      reject(reader.error);
    };
  });
